import * as React from "react";
const SvgPrivateOffice = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.936 6.847 3.858 8.752 6.293 11H10V8.75c0-.966.784-1.75 1.75-1.75h3.5c.966 0 1.75.784 1.75 1.75V11h4.25a.75.75 0 0 1 .75.75v9.5a.75.75 0 1 1-1.5 0V12.5H17v1h.25c.966 0 1.75.784 1.75 1.75v1A1.75 1.75 0 0 1 17.25 18h-3v1.76l1.805.802a.75.75 0 1 1-.61 1.37l-1.944-.864-1.946.865a.75.75 0 1 1-.61-1.37l1.806-.803V18H9.75A1.75 1.75 0 0 1 8 16.25v-1c0-.966.783-1.75 1.75-1.75H10v-1H3.5v8.75a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 .75-.75h1.332l-1.84-1.699a.75.75 0 0 1 .001-1.104l2.7-2.475a2.501 2.501 0 0 1 3.95-2.99l.884.884a.75.75 0 0 1 0 1.06L7.302 7.153a.75.75 0 0 1-1.06 0l-.306-.305Zm.482-1.64.354.354 1.414-1.415-.354-.353a1 1 0 0 0-1.414 1.414ZM15.5 8.75a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25v7.75h4V8.75ZM17 15v1.5h.25a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25H17Zm-7 0h-.25a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25H10V15Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgPrivateOffice;
